module.exports = __webpack_public_path__ + "assets/img/000f-la.svg";